import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const invalidationResponse = defineMessage({
  type: 'invalidate-nav-config-response',
  payloadSchema: t.object({
    success: t.boolean,
    errorMessage: t.optional(t.string)
  })
});
const requestInvalidation = defineMessage({
  type: 'invalidate-nav-config-request',
  payloadSchema: t.object({
    source: t.string // Who is requesting the invalidation
  }),
  reply: invalidationResponse
});
export const navConfigControls = {
  requestInvalidation,
  invalidationResponse
};